<template>
  <b-modal
    id="addShiftUser"
    :title="$translate('Add Employee')"
    hide-footer
    size="lg"
    centered
    content-class="rounded-8"
    @close="clear"
    @show="show"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Select v-model="value" :options="userOptions" form-group-id="Employee" placeholder="Employee" required />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 button-wrapper">
        <b-button variant="outline-secondary" size="lg" class="btn-delete-device px-5" @click="close">
          {{ 'Close' | i18n }}
        </b-button>
        <b-button variant="outline-primary" size="lg" class="btn-delete-device ml-4 px-5" :disabled="!value" @click="onSubmit">
          {{ 'Save' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Select from '../../common/select';
import { NotificationMixin } from '../../../../mixins';
import api from '../../../api';

export default {
  title: 'Add user',
  components: { Select },
  mixins: [NotificationMixin],
  props: {
    onSave: {
      type: Function,
      default: () => {}
    },
    selectedUsers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      value: '',
      userOptions: [],
      users: []
    };
  },
  methods: {
    onSubmit() {
      const u = this.users.find(u => u.id === this.value);
      this.onSave(u);
      this.close();
    },
    async show() {
      this.clear();
      const response = await api.teams.getUsersLookup();
      const u = response.data;
      this.users = u;
      const existIds = this.selectedUsers.map(u => u.id);
      const filtered = u.filter(u => !existIds.includes(u.id));
      this.userOptions = filtered.map(item => ({
        value: item.id,
        text: `${item.username ? item.username : ''}${item.email ? ` (${item.email})` : ''}`
      }));
    },
    close() {
      this.$root.$emit('bv::hide::modal', 'addShiftUser');
      this.clear();
    },
    clear() {
      this.value = '';
      this.userOptions = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
